import { USER_LOGIN, SIGN_IN, SIGN_OUT, SET_LOADER } from './actions';
import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';
import { setCookie } from 'utils/cookies';
import Utils from 'utils/utils';

const defaultState = {
  loader: false,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case USER_LOGIN[REQUEST]:
      return { ...state };
    // window.location.href = window.location.origin + '/portal/login';
    case USER_LOGIN[FAILURE]:
      return { ...state };
    // window.location.href = window.location.origin + '/portal/login';
    case USER_LOGIN[SUCCESS]: {
      setCookie('email', action.response.email);
      window.location.href = window.location.origin + '/portal/operator';
      return { ...state };
    }
    // return {...state, user: action.email, loggedIn: true} Login handling from Google callback success
    case SIGN_IN: {
      setCookie('email', action.profile.email);
      window.location.href = window.location.origin + '/portal/operator';
      return { ...state, user: action.profile, token: action.token, loggedIn: true }; // handling user info from Google
    }
    // return { ...state };
    case SIGN_OUT: {
      document.cookie = '';
      Utils.reAuthenticate();
      return { ...state, user: {}, token: null, loggedIn: false };
    }
    case SET_LOADER:
      return { ...state, loader: !state.loader };
    default:
      return state;
  }
}

export const getUser = (state) => state.app;
export const getLoader = (state) => state.app.loader;
